import {CALL_API} from 'middleware/api';
import {TRANSFORM} from 'middleware/transform';

import * as ActionTypes from '../Line';

function fetchFullLine(data) {
    const {languageId, eventId} = data;

    return {
        type: ActionTypes.REQUEST_FULL_LINE,
        [CALL_API]: {
            endpoint: `/api/event/${eventId}/full?languageId=${languageId}`,
            method: 'get',
            types: [
                ActionTypes.SUCCESS_REQUEST_FULL_LINE,
                ActionTypes.FAILURE_REQUEST_FULL_LINE
            ],
            data
        },
        [TRANSFORM]: {
            section: 'preMatch',
            transformType: 'init',
            provider: (data) => data
        }
    };
}

export function requestFullLine(data) {
    return (dispatch) => {
        return dispatch(fetchFullLine(data));
    };
}

function fetchLineHeaders(data) {
    const {languageId} = data;

    return {
        type: ActionTypes.REQUEST_LINE_HEADERS,
        [CALL_API]: {
            endpoint: `/api/line/headers?languageId=${languageId}`,
            method: 'get',
            types: [
                ActionTypes.SUCCESS_REQUEST_LINE_HEADERS,
                ActionTypes.FAILURE_REQUEST_LINE_HEADERS
            ],
            data
        },
        [TRANSFORM]: {
            section: 'preMatch',
            transformType: 'init',
            provider: (data) => data
        }
    };
}

export function requestLineHeaders(data) {
    return (dispatch) => {
        return dispatch(fetchLineHeaders(data));
    };
}

function fetchSportLineHeaders(data) {
    const {sportId, languageId} = data;

    return {
        type: ActionTypes.REQUEST_SPORT_LINE_HEADERS,
        [CALL_API]: {
            endpoint: `/api/line/sport/${sportId}/headers?languageId=${languageId}`,
            method: 'get',
            types: [
                ActionTypes.SUCCESS_REQUEST_SPORT_LINE_HEADERS,
                ActionTypes.FAILURE_REQUEST_SPORT_LINE_HEADERS
            ],
            data
        },
        [TRANSFORM]: {
            section: 'preMatch',
            transformType: 'init',
            provider: (data) => data
        }
    };
}

export function requestSportLineHeaders(data) {
    return (dispatch) => {
        return dispatch(fetchSportLineHeaders(data));
    };
}

function fetchLeagueLineHeaders(data) {
    const {leagueId, languageId} = data;

    return {
        type: ActionTypes.REQUEST_LEAGUE_LINE_HEADERS,
        [CALL_API]: {
            endpoint: `/api/line/league/${leagueId}/headers?languageId=${languageId}`,
            method: 'get',
            types: [
                ActionTypes.SUCCESS_REQUEST_LEAGUE_LINE_HEADERS,
                ActionTypes.FAILURE_REQUEST_LEAGUE_LINE_HEADERS
            ],
            data
        },
        [TRANSFORM]: {
            section: 'preMatch',
            transformType: 'init',
            provider: (data) => data
        }
    };
}

export function requestLeagueLineHeaders(data) {
    return (dispatch) => {
        return dispatch(fetchLeagueLineHeaders(data));
    };
}

export function clearLine() {
    return {type: ActionTypes.CLEAR_LINE, section: 'preMatch'};
}

export function showLineNumbers(section) {
    return {type: ActionTypes.SHOW_LINE_NUMBERS, section: section}
}
export function hideLineNumbers(section) {
    return {type: ActionTypes.HIDE_LINE_NUMBERS, section: section}
}



// WEBPACK FOOTER //
// ./js/actions/creators/Line.js